/**
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

function ContactUs() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          justifyContent="center"
          xs={10}
          lg={6}
          sx={{ mx: "auto", mb: { xs: 0, md: 6 }, textAlign: "center" }}
        >
          <MKTypography variant="h3" mb={1}>
          HABEN WIR DEIN INTERESSE GEWECKT?
          </MKTypography>
          <MKTypography variant="body2" color="text">
          Dann freuen wir uns auf deine Bewerbung. Schick uns je nach Stelle auch gerne weitere Referenzen.
          Über eine persönliche Vorstellung und deine Beweggründe würden wir uns ebenfalls freuen.
          </MKTypography>
          <MKTypography variant="body2" color="text">
          Sende jetzt deine Bewerbung an bewerbung@western-hills.de
          </MKTypography>
          <Container sx={{ my:2 }}>
          <MKButton type="submit" variant="gradient" color="dark" onClick={() => {
        window.location.href = "mailto:bewerbung@western-hills.de?subject=Bewerbung";
    }}>
                  Email Schreiben
          </MKButton>
          </Container>
        </Grid>
        <Grid container item xs={12} lg={8} sx={{ mx: "auto" }}>
          <MKBox width="100%" component="form" method="post" autoComplete="off">
            {/*<MKBox p={3}>
               <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <MKInput
                    variant="standard"
                    label="Name"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <MKInput
                    type="email"
                    variant="standard"
                    label="Email"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <MKInput
                    variant="standard"
                    label="Deine Bewerbung"
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    multiline
                    fullWidth
                    rows={6}
                  />
                </Grid>
              </Grid>
              <Grid container item justifyContent="center" xs={12} my={6}>
                <MKButton type="submit" variant="gradient" color="dark">
                  Send Message
                </MKButton>
              </Grid> 
             
            </MKBox>*/}
            <MKTypography variant="body2" color="text" textAlign="center">
              Nicht aufgelistete Stellen auf Anfrage und Initiativ-Bewerbung direkt an bewerbung@western-hills.de oder per Ticket in unserem Discord.
            </MKTypography>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ContactUs;
